import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { cn } from "$lib/utils.js";

var root = $.from_html(`<div><!></div>`);

export default function Card_action($$anchor, $$props) {
	$.push($$props, true);

	let ref = $.prop($$props, 'ref', 15, null),
		restProps = $.rest_props($$props, [
			'$$slots',
			'$$events',
			'$$legacy',
			'ref',
			'class',
			'children'
		]);

	var div = root();

	$.attribute_effect(div, ($0) => ({ 'data-slot': 'card-action', class: $0, ...restProps }), [
		() => cn("col-start-2 row-span-2 row-start-1 self-start justify-self-end", $$props.class)
	]);

	var node = $.child(div);

	$.snippet(node, () => $$props.children ?? $.noop);
	$.reset(div);
	$.bind_this(div, ($$value) => ref($$value), () => ref());
	$.append($$anchor, div);
	$.pop();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiY2FyZC1hY3Rpb24uc3ZlbHRlIl0sInNvdXJjZXNDb250ZW50IjpbIjxzY3JpcHQgbGFuZz1cInRzXCI+XG5cdGltcG9ydCB7IGNuLCB0eXBlIFdpdGhFbGVtZW50UmVmIH0gZnJvbSBcIiRsaWIvdXRpbHMuanNcIjtcblx0aW1wb3J0IHR5cGUgeyBIVE1MQXR0cmlidXRlcyB9IGZyb20gXCJzdmVsdGUvZWxlbWVudHNcIjtcblxuXHRsZXQge1xuXHRcdHJlZiA9ICRiaW5kYWJsZShudWxsKSxcblx0XHRjbGFzczogY2xhc3NOYW1lLFxuXHRcdGNoaWxkcmVuLFxuXHRcdC4uLnJlc3RQcm9wc1xuXHR9OiBXaXRoRWxlbWVudFJlZjxIVE1MQXR0cmlidXRlczxIVE1MRGl2RWxlbWVudD4+ID0gJHByb3BzKCk7XG48L3NjcmlwdD5cblxuPGRpdlxuXHRiaW5kOnRoaXM9e3JlZn1cblx0ZGF0YS1zbG90PVwiY2FyZC1hY3Rpb25cIlxuXHRjbGFzcz17Y24oXCJjb2wtc3RhcnQtMiByb3ctc3Bhbi0yIHJvdy1zdGFydC0xIHNlbGYtc3RhcnQganVzdGlmeS1zZWxmLWVuZFwiLCBjbGFzc05hbWUpfVxuXHR7Li4ucmVzdFByb3BzfVxuPlxuXHR7QHJlbmRlciBjaGlsZHJlbj8uKCl9XG48L2Rpdj5cbiJdLCJtYXBwaW5ncyI6Ijs7U0FDVSxFQUFFLFFBQTZCLGVBQWU7Ozs7dURBRHhELENBQUM7OztLQUtDLEdBQUcsOEJBQWEsSUFBSTtFQUdqQixTQUFTOzs7Ozs7Ozs7Ozs4RUFRVCxTQUFTO1FBRE4sRUFBRSxDQUFDLGdFQUFnRTs7Ozs7OzsrQkFGL0QsR0FBRyxpQkFBSCxHQUFHOzs7QUFIaEIsQ0FBQyJ9